import dynamic from 'next/dynamic';

import { DynamicDecorator } from '@natu/ui/Decorators/DynamicDecorator';

import { type BlokItem, type SBProps } from '../../../../../utils';

const Typography = dynamic(() => import('@natu/ui/Typography').then(mod => mod.Typography));

const DynamicRender = dynamic(() => import('../../../../../utils').then(mod => mod.DynamicRender));

interface SBSuccessStateProps {
  headingTag?: 'h1' | 'h2' | 'h3';
  heading?: string;
  subheading?: string;
  socials?: [BlokItem];
}

export const SBSuccessState = ({ blok }: SBProps<SBSuccessStateProps>) => {
  const { headingTag, heading, subheading, socials } = blok;

  return (
    <div className="rounded-2xl bg-white px-6 py-8 shadow-2xl xl:px-10 xl:py-14">
      <div className="relative mb-10 h-72 overflow-hidden">
        <DynamicDecorator
          decorator="circle"
          className="text-primary-600 absolute -left-14 top-10 size-28"
        />
        <DynamicDecorator
          decorator="circle"
          className="text-naturaily-butterscotch absolute left-32 top-24 size-40"
        />
        <DynamicDecorator
          decorator="halfStadium"
          className="absolute right-24 top-4 h-auto w-12 text-gray-100"
        />
        <DynamicDecorator
          decorator="quadrant"
          className="text-naturaily-airborne absolute bottom-0 right-0 size-11"
        />
        <Typography className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-6xl">
          🚀
        </Typography>
      </div>
      {heading && (
        <Typography
          component={headingTag || 'h2'}
          variant="display-md-34"
          className="mb-10 text-center font-semibold"
        >
          {heading}
        </Typography>
      )}
      {subheading && (
        <Typography className="mb-6 text-center font-medium text-gray-700">{subheading}</Typography>
      )}

      {socials && (
        <div className="mx-auto max-w-52">
          <DynamicRender data={socials} />
        </div>
      )}
    </div>
  );
};
